import { render, staticRenderFns } from "./AssignmentManager.vue?vue&type=template&id=7976eb00&"
import script from "./AssignmentManager.vue?vue&type=script&lang=js&"
export * from "./AssignmentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports